/**
 * scripts.js
 */
(function ($, Drupal, drupalSettings, once) {
  'use strict';

  Drupal.behaviors.carousel = {
    attach(context, settings) {

      const swiper = new Swiper('.paragraph--type--cards-slider .swiper.card-slider-h', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
      });

      const swiper2 = new Swiper('.paragraph--type--cards-slider .swiper.card-slider-v', {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 10,
        centerInsufficientSlides: true,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        scrollbar: {
          el: '.swiper-scrollbar',
        },
        // Responsive breakpoints
        breakpoints: {
          1024: {
            slidesPerView: 3,
            spaceBetween: 10
          },
          767: {
            slidesPerView: 2,
            spaceBetween: 10
          },
          575: {
            slidesPerView: 1,
            spaceBetween: 5
          }
        }
      });

      const swiper3 = new Swiper('.wrapper-gallery .swiper', {
        loop: true,
        slidesPerView: 1,
        pagination: {
          el: ".swiper-pagination",
          type: "fraction",
        },
        scrollbar: {
          el: '.swiper-scrollbar',
          hide: false,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });

      /*Brand Slider*/
      context.querySelectorAll('.paragraph--type--brands-slider.paragraph--view-mode--default:not(.processed)').forEach((el) => {
        const $paragraph = $(el);
        var brandSlider = $('.brand-slider', $paragraph);
        brandSlider.owlCarousel({
          items: 1,
          dots: false
        });
        brandSlider.on('changed.owl.carousel', function(event) {
          activeItem(event.item.index);
        });
        var navSlider = $('.nav--brand-slider', $paragraph);
        const activeItem = (index) => {
          const $item = $('.nav--brand-slider li', $paragraph);
          $item.removeClass('active');
          $item.eq(index).addClass('active');
        };
        navSlider.on('click', 'li', function(e) {
          brandSlider.trigger('to.owl.carousel', [$(this).index(), 300]);
          activeItem($(this).index());
        });
        el.classList.add('processed');
      });



      /*Slider Services*/
      $(window).on('load', function(){
        $('.slider').slick({
          dots: true,
          fade: true,
          infinite: false,
          arrows: true,
          prevArrow: '<button class="slick-prev slide-arrow">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left"' +
            ' viewBox="0 0 16 16">\n' +
            '  <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 ' +
            '0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>\n' +
            '</svg></button>',
          nextArrow: '<button class="slick-next slick-arrow">' +
            '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right"' +
            ' viewBox="0 0 16 16">\n' +
            '  <path fill-rule="evenodd" d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0' +
            ' 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"/>\n' +
            '</svg></button>',
          responsive: [
            {
              breakpoint: 991,
              settings: {
                dots: false,
              }
            }
          ]
        });
        placeDots(getDots(".slider"));
      });

      // @param function that returns list of dots from specific slider
      function placeDots(dots) {
        // How many points along the circle. The higher number the shorter the distance between dots
        var points = 12;

        // Circle radius
        var r = 370;

        // Center of circle
        var cx = 350, cy = 350;

        for (var i = 0; i < dots.length; i++) {
          var deg = 360 / points * i;
          var rad = deg * Math.PI / 180

          var x = cx + r * Math.cos(rad);
          var y = cy + r * Math.sin(rad);

          // Subtract amount equal to half of dots width
          x = x - 5; y = y - 5;

          dots[i].style.left = "" + x + "px";
          dots[i].style.top = "" + y + "px";
        }
      }

      // @param slider class name
      function getDots(slider) {
        var dots = $('' + slider + ' .slick-dots').children();
        return dots;
      }
    },
  }

  Drupal.behaviors.product = {
    attach(context, setting) {

      var lightboxprev = $('.modal .carousel-control-prev');
      var lightboxnext = $('.modal .carousel-control-next');
      lightboxprev.append(
        '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-chevron-left\" viewBox=\"0 0 16 16\">\n' +
        '  <path fill-rule=\"evenodd\" d=\"M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z\"/>\n' +
        '</svg>'
      );
      lightboxnext.append(
        '<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-chevron-right\" viewBox=\"0 0 16 16\">\n' +
        '  <path fill-rule=\"evenodd\" d=\"M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z\"/>\n' +
        '</svg>'
      );
    },
  }

  Drupal.behaviors.menu = {
    attach: function (context, settings) {

      // Primary navigation behaviors.
      $('.menu-items .main-menu--desktop', context).each(function (element) {
        $(this).find('li').each(function(item){
          let level = $(this).data('level');
          let route = $(this).data('route');

          if ($(this).hasClass('menu-item--active-trail')) {
            $(this).parent().css('display', 'block')
          }

          switch(level){
            case 0:
              $(this).mouseover(function(e) {
                e.preventDefault();
                toggleElementMenu(context, route, 'sub-items', 'sec-sub-items' , 'third-sub-items')
              });
              break;
            case 1:
              $(this).mouseover(function(e) {
                e.preventDefault();
                toggleElementMenu(context, route,  'sec-sub-items' , 'third-sub-items')
              });
              break;
            case 2:
              $(this).mouseover(function(e) {
                e.preventDefault();
                toggleElementMenu(context, route,  'third-sub-items')
              });
              break;
            case 3:
              $(this).mouseover(function(e){
                e.preventDefault();
                toggleElementMenu(context, route)
              });
              break;
          }
        });

      });

    },
  }

  Drupal.behaviors.contacts = {
    attach: function (context, settings) {
      const contactWrapper = $('.wrapper-tabs-content .collapse').first();
      contactWrapper. prop("class", "collapse show");
      $('#v-pills-tab').on('click','.nav-item',function(){
        $(this).removeClass('collapsed').siblings().addClass('collapsed').attr('aria-expanded', 'false');
        $('.wrapper-tabs-content .collapse').removeClass("show");
      });
    },
  }

  Drupal.behaviors.contactUsButton = {
    attach: function (context, settings) {
      const $block =  once('contactUsButton', $('.contact-us-button'));
      $('.contact-us-button__item', $block).on('click', function (e) {
        $('.contact-us-button__content', $block).toggleClass('open');
      });
    },
  }

  Drupal.behaviors.navbarToggler = {
    attach: function (context, settings) {
      const $navbarToggler = $('.navbar-toggler', context);
      $navbarToggler.on('click', function (e) {
        $(this).toggleClass('open');
      });
    },
  }

  Drupal.behaviors.mainMobileMenu = {
    attach: function (context, settings) {
      const $mobileMenu = $('.main-menu--mobile', context);
      $('.menu-item--expanded > a svg', $mobileMenu).on('click', function (e) {
        e.preventDefault();
        const $this = $(this).parent();
        $this.toggleClass('show');
        $this.parent().toggleClass('show');
        $this.next().toggleClass('show');
      });
    },
  }

  Drupal.behaviors.languageSelector = {
    attach: function (context, settings) {
      const $languageSelect = $('.lang-dropdown-select-element', context);
      $languageSelect.select2({
        minimumResultsForSearch: -1,
        width: '100px',
        selectionCssClass: 'language-selector',
        dropdownCssClass: 'language-selector'
      });
    },
  }

  Drupal.behaviors.eptaFixedContainer = {
    attach: function (context, settings) {
      context.querySelectorAll('.fixed-container:not(.js-processed)')
        .forEach(el => {
          const topPosition = 0;
          const elOffsetTop = el.offsetTop;
          window.addEventListener('scroll', function () {
            const offsetScroll = window.scrollY || window.pageYOffset;
            if (offsetScroll >= elOffsetTop) {
              console.log('scrolled');
              el.classList.add('scrolled');
            } else {
              el.classList.remove('scrolled');
            }
          });
          el.classList.add('js-processed');
      });
    },
  }


  $(document).on('change','#pageSelection',function(){
    var url = $(this).val(); // get selected value
    if (url) { // require a URL
      window.location = url; // redirect
    }
    return false;
  });

  /**
   * Hide or display the child menu level.
   *
   * @param context
   * @param itemsId
   * @param subItems
   * @param secondSubItems
   * @param thirdSubItems
   */
  function toggleElementMenu(context, itemsId, subItems, secondSubItems, thirdSubItems) {
    let menu = $('#' + itemsId, context);
    let subElements = $('.' + subItems, context);
    let secondSubElements = $('.' + secondSubItems, context);
    let thirdSubElements = $('.' + thirdSubItems, context);

    if (menu.css('display') === "none" || menu.length === 0) {
      for (let i = 0; i < subElements.length; i++) {
        subElements[i].style.display = "none";
      }
      for (let i = 0; i < secondSubElements.length; i++) {
        secondSubElements[i].style.display = "none";
      }
      for (let i = 0; i < thirdSubElements.length; i++) {
        thirdSubElements[i].style.display = "none";
      }
      menu.show();
    }
  }

  function resizeTextMedia(){
    let wrapper = $('.paragraph--type--text-media');
    let subImg = $(this).children('.wrapper-media img');
    let newHeight = subImg.height();
    if ($(window).width() > 960) {
      wrapper.height(newHeight);
    }
  }
  resizeTextMedia();
  $(window).resize(function(){
    resizeTextMedia();
  });

  })(jQuery, Drupal, drupalSettings, once);
